import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=dc49ef06&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&id=dc49ef06&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc49ef06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/compass-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc49ef06')) {
      api.createRecord('dc49ef06', component.options)
    } else {
      api.reload('dc49ef06', component.options)
    }
    module.hot.accept("./SvgIcon.vue?vue&type=template&id=dc49ef06&scoped=true", function () {
      api.rerender('dc49ef06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SvgIcon.vue"
export default component.exports